import { FadeLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Stack, Typography } from '@mui/material';
import AnnouncementForm from '../../sections/@dashboard/announcements/AnnouncementForm';
import Page from '../../components/Page';
import tracker from '../../api/tracker';
import PrintButton from '../../components/print/PrintButton';
import AnnouncementPrintTemplate from '../../sections/@dashboard/announcements/AnnouncementPrintTemplate';

export default function EditAnnouncement() {
  const [loading, setLoading] = useState(true);
  const { hashid } = useParams();
  const [announcement, setAnnouncement] = useState();
  const { t } = useTranslation();
  const fetchUserData = async () => {
    const response = await tracker.get(`announcements/${hashid}`);
    setAnnouncement(response.data.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchUserData();
  }, [hashid]);

  return (
    <>
      <AnnouncementPrintTemplate announcement={announcement} />
      <Page title={t('announcement_form')}>
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} sx={{ mb: 4 }}>
            <Typography variant="h4">
              {t('edit_announcement') || 'Editar Anuncio'}
            </Typography>
            {!loading && announcement && <PrintButton />}
          </Stack>
          <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
            {loading ? (
              <FadeLoader color="blue" cssOverride={{ margin: '0 auto' }} loading={loading} />
            ) : (
              <AnnouncementForm announcement={announcement} />
            )}
          </Box>
        </Container>
      </Page>
    </>
  );
}
